import * as React from "react";
import { ITasks } from "./types";

export const MemberTasksContext = React.createContext<ITasks>({
  mnpPortout: undefined,
});

export function useMemberTasks() {
  const value = React.useContext(MemberTasksContext);

  if (value === null) {
    throw new Error("`Missing MemberTasksContext` in tree.");
  }

  return value;
}
